import { render, staticRenderFns } from "./CardPrice.vue?vue&type=template&id=470d5947&scoped=true&"
import script from "./CardPrice.vue?vue&type=script&lang=js&"
export * from "./CardPrice.vue?vue&type=script&lang=js&"
import style0 from "./CardPrice.vue?vue&type=style&index=0&id=470d5947&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d5947",
  null
  
)

export default component.exports